var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g(_vm._b({tag:"component",staticClass:"ui-outline-button",class:[
    `ui-outline-button--${_vm.theme}`,
    {
      'is-active': _vm.active,
      'is-disabled': _vm.disabled,
      'is-full-width': _vm.fullWidth,
    },
  ],on:{"dragstart":function($event){$event.preventDefault();}}},'component',_vm.componentAttributes,false),_vm.$listeners),[_c('span',{staticClass:"ui-outline-button__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }